var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var NotFound = function () {
    return (_jsx("div", __assign({ className: 'd-flex align-items-center justify-content-center w-100' }, { children: _jsx("div", __assign({ className: 'd-flex flex-center flex-column py-10 px-10' }, { children: _jsx("div", __assign({ className: 'text-center' }, { children: _jsx("span", { children: "Tidak ada data" }) })) })) })));
};
export default NotFound;
